/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class UnionAPI
 * @hideconstructor
 * @classdesc Provides access to the the union object associated to a dataitem.
 */
define([], () => {
	return class UnionAPI {

		/**
		 * @function UnionAPI#getDataItemList
		 * @description Gets a list of its expanded children dataItems
		 * @public
		 *
		 * @returns {DataItemAPI[]}
		 */
		getDataItemList() { }

		/**
		 * @function UnionAPI#getDataItem
		 * @description Gets the expanded child dataitem with the id passed in
		 * @public
		 *
		 * @param {String} Id dataitem id to find
		 * @returns {DataItemAPI}
		 */
		getDataItem( /*id*/){ }

		/**
		 * @function UnionAPI#setDataItems
		 * @description sets the children of this dataItem to the models passed in
		 * @public
		 *
		 * @param {Array} dataItemPropsList dataItem properties to set the children to
		 * @param {Object} transactionToken
		 * @returns {[DataItemAPI]}
		 */
		setDataItems( /*dataItemPropsList, transactionToken*/){ }

		/**
		 * @function UnionAPI#addColumn
		 * @description adds a new child dataItem model and returns its dataItemAPI
		 * @public
		 *
		 * @param {Object} dataItemProps attributes for the dataitem.
		 * @param {Object} transactionToken
		 * @returns {DataItemAPI} added dataItem
		 */
		addDataItem( /*dataItemProps, transactionToken*/){ }

		/**
		 * @function UnionAPI#removeColumn
		 * @description removes the child dataItem model with the id passed in
		 * @public
		 *
		 * @param {String} dataItemId id of dataItem to remove
		 * @param {Object} transactionToken
		 * @returns {DataItemAPI} removed dataItem
		 */
		removeDataItem( /*dataItemId, transactionToken*/){ }
	};
});
